import { Checkbox } from "antd"
import styled from "styled-components"

const BooleanField = styled(Checkbox)`
  margin-inline-start: 0px !important;
`

export { BooleanField }
